import styled from 'styled-components';
import { themeGet } from '@styled-system/theme-get';

import Image from '../../../Core/Image';

export const Card = styled.li`
  flex: none;
  display: flex;
  flex-direction: column;
  position: relative;
  width: 100%;
  border-radius: 0.625rem;
  box-shadow: 0px 4px 10px 0px rgba(0, 0, 0, 0.1);
  background: ${({ $backgroundColor }) =>
    $backgroundColor ? themeGet(`colors.${$backgroundColor}`) : 'white'};
  overflow: hidden;

  @media only screen and (min-width: ${themeGet('breakpoints.md')}) {
    max-width: 100%;
    margin: 0;
  }
`;

export const Content = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  padding: 1.5rem;

  @media only screen and (min-width: ${themeGet('breakpoints.md')}) {
    max-width: 100%;
    margin: 0;
  }
`;

export const ImageWrapper = styled.div`
  display: flex;
  width: 100%;
  justify-content: center;
`;

export const Img = styled(Image)``;

export const Heading = styled.div`
  display: flex;
  flex-direction: column;
  row-gap: 1rem;
  padding: 0 0 1.5rem;
  h3 {
    display: flex;
    align-items: center;
    span {
      margin-right: 0.75rem;
      font-size: 1rem;
    }
  }
  p {
    font-size: 1rem;
    line-height: 1.5rem;
  }

  @media only screen and (min-width: ${themeGet('breakpoints.md')}) {
    padding: 0 0.5rem 1.5rem;
  }
`;

export const Body = styled.div`
  display: inline;
  border-top: 1px solid ${themeGet('colors.cta-border-grey')};
  ul {
    li:not(:first-child) {
      margin: 1.5rem 0;
    }
  }
`;

export const IconText = styled.div`
  display: flex;
  column-gap: 1rem;
  align-items: center;

  h3 {
    font-size: 1.5rem;
  }
`;

export const StyledIcon = styled(Image)`
  max-width: 2rem;
  max-height: 2rem;
  width: 100%;
  height: 100%;
`;
